import type { Color } from "@scrolly/post-types";
import THREE from "../THREE";

export function threeToColor(threeColor: THREE.Color, alpha: number = 1): Color {
    return {
        r: Math.round(threeColor.r * 255),
        g: Math.round(threeColor.g * 255),
        b: Math.round(threeColor.b * 255),
        a: alpha,
    };
}
